import { render } from "./SPbarchart.vue?vue&type=template&id=7cc486c6&scoped=true"
import script from "./SPbarchart.vue?vue&type=script&lang=js"
export * from "./SPbarchart.vue?vue&type=script&lang=js"

import "./SPbarchart.vue?vue&type=style&index=0&id=7cc486c6&scoped=true&lang=css"
import "./SPbarchart.vue?vue&type=style&index=1&id=7cc486c6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc486c6"]])

export default __exports__